import React, { useRef, useState } from 'react';
import { IonModal, IonSlides, IonSlide, IonItem, IonInput, IonButton, IonHeader, IonGrid, IonRow, IonCol, IonLabel, IonContent, IonFooter, } from '@ionic/react';


import '../../css/layout.css';

export function Application_SubmissionModal(props) {

    let [baseURL, setBaseURL ] = useState(window.location.origin+"/");
    const [acctID, setAcctID ] = useState('1');


    let [selectedFile, setSelectedFile] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");

    let [applicantCountryRegion, setApplicantCountryRegion] = useState('Eastern');
    let [applicantCountry, setApplicantCountry] = useState('Ghana');
    let [disableSubmitApplicationButton, setDisableSubmitApplicaitonButton] = useState(false);


    let enterFirstNameRef = useRef(null);
    let enterMiddleNameRef = useRef(null);
    let enterLastNameRef = useRef(null);
    let enterMobileNumberRef = useRef(null);
    let enterEmailRef = useRef(null);

    let applicantAddressNumberRef = useRef('');
    let applicantStreetNameRef = useRef('');
    let applicantCityRef = useRef('');
    let applicantCityDistrictRef = useRef('');
    let applicantCountryRegionRef = useRef('');
    let applicantCountryRef = useRef('');
    let applicantDigitalAddressIDRef = useRef('');
    let applicantTextRef = useRef('');


    function submitApplication()
    {

        setDisableSubmitApplicaitonButton(true);

        let formData = new FormData();
        formData.append('Tracker', '74503_submitApplication_public');
        formData.append('user', acctID);
        formData.append('xJobRequisitionID', props.data.requisitionID);
        formData.append('xJobRequisitionName', props.data.requisitionName);
        formData.append('xApplicantFirstName', enterFirstNameRef.current.value.replace(/\s+/g, ''));
        formData.append('xApplicantMiddleName', enterMiddleNameRef.current.value.replace(/\s+/g, ''));
        formData.append('xApplicantLastName', enterLastNameRef.current.value.replace(/\s+/g, ''));
        formData.append('xApplicantMobileNumber', enterMobileNumberRef.current.value.replace(/\s+/g, ''));
        formData.append('xApplicantEmail', enterEmailRef.current.value.replace(/\s+/g, ''));
        formData.append('xApplicantAddressNumber', applicantAddressNumberRef.current.value.replace(/\s+/g, ''));
        formData.append('xApplicantStreetName', applicantStreetNameRef.current.value.replace(/\s+/g, ''));
        formData.append('xApplicantCity', applicantCityRef.current.value.replace(/\s+/g, ''));
        formData.append('xApplicantCityDistrict', applicantCityDistrictRef.current.value.replace(/\s+/g, ''));
        formData.append('xApplicantCountryRegion', applicantCountryRegion);
        formData.append('xApplicantCountry', applicantCountry);
        formData.append('xApplicantDigitalAddressID', applicantDigitalAddressIDRef.current.value);
        formData.append('xResume', selectedFile);
        formData.append('xApplicationText', applicantTextRef.current.value)

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }

        fetch(baseURL+'public_request', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }


    function handleFileChange(event) {


        const file = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);
        //setFileName(file ? file.name : '');
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
            <IonModal isOpen={ props.openModal }>
            <IonHeader className='grid_header'>
                <IonGrid>

                    <IonRow>
                        <IonCol size='12'> {props.data.requisitionName} Application</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'> Requisition ID: {props.data.requisitionID}</IonCol>
                    </IonRow>

                </IonGrid >  
            </IonHeader> 
            <IonContent className='grid_content'>  
                    <IonGrid >
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>First Name: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput placeholder='Enter First Name' ref={enterFirstNameRef }></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Middle Name: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput placeholder='Enter Middle Name' ref={enterMiddleNameRef }></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Last Name: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput placeholder='Enter Last Name' ref={enterLastNameRef }></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Mobile Number: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput placeholder='Enter Mobile Number' ref={enterMobileNumberRef}></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Email: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput placeholder='Enter Email' ref={enterEmailRef}></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Address Number: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput type='text' placeholder='Enter address number' ref={ applicantAddressNumberRef }></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Street Name: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput type='text' placeholder='Enter Street Name' ref={ applicantStreetNameRef }></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>City: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput type='text' placeholder='Enter City' ref={ applicantCityRef }></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>City District: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput type='text' placeholder='Enter City District' ref={ applicantCityDistrictRef }></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Digital Address: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput type='text' placeholder='Enter City District' ref={ applicantDigitalAddressIDRef }></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel htmlFor="country">Country</IonLabel>                                    
                            </IonCol>
                            <IonCol size='6'>
                                <select name="country" id='country' onChange={(e) => setApplicantCountry(e.target.value) }>
                                    <option value='Ghana' selected='selected'>Ghanian</option>
                                    <option value='Non-Ghanian'>Non-Ghanian</option>
                                </select>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel htmlFor="paymenttype">Region</IonLabel>                                    
                            </IonCol>
                            <IonCol size='6'>
                                <select name="countryRegion" id='countryRegion' onChange={(e) => setApplicantCountryRegion(e.target.value) }>
                                    <option value='Eastern' selected='selected'>Eastern</option>
                                    <option value='Western'>Western</option>
                                    <option value='Central'>Central</option>
                                    <option value='Northern'>Northern</option>
                                </select>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <textarea cols="50" rows="10" placeholder='Enter Position Qualifications (3000 characters max)' ref={ applicantTextRef }></textarea>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <form id='fileUpload' encType='multipart/form-data'>
                                    <label htmlFor='application_resume'>Resume</label>
                                        <input id='application_resume' type="file" name='xResume' accept=".doc,.docx,.pdf,.jpeg,.jpg,.png,.odt" onChange={(event) => handleFileChange(event)} required></input>
                                </form>                                        
                            </IonCol>
                        </IonRow>

                    </IonGrid>
            </IonContent>

            <IonFooter className='grid_footer'>
                <IonGrid>
                    <IonCol>
        
                        <IonButton className='application_button_footer' onClick={() => closeModalHandler(false)}> Cancel </IonButton>
                        <IonButton className='application_button_footer' disabled={disableSubmitApplicationButton} onClick={() => submitApplication()}> Submit Application </IonButton>

                    </IonCol>
                </IonGrid>
            </IonFooter>

            </IonModal>
            ) : null}
    </React.Fragment>
    )
}
